/** Official SportsFuture YouTube playlist — no Google Data API. */
export const SPORTS_FUTURE_PLAYLIST_ID = 'PLHlf_ssJTHkcDSduPJ07kM0izAfrmX-wK';

export type PlaylistVideo = {
  id: string;
  title: string;
  description: string;
  publishedAt: string;
  thumbnail: string;
  channelTitle: string;
};

export function youtubeThumbnail(videoId: string): string {
  return `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;
}

export function youtubeWatchUrl(videoId: string, playlistId = SPORTS_FUTURE_PLAYLIST_ID): string {
  return `https://www.youtube.com/watch?v=${videoId}&list=${playlistId}`;
}

export function youtubePlaylistUrl(playlistId = SPORTS_FUTURE_PLAYLIST_ID): string {
  return `https://www.youtube.com/playlist?list=${playlistId}`;
}

export function youtubeEmbedPlaylistUrl(playlistId = SPORTS_FUTURE_PLAYLIST_ID): string {
  return `https://www.youtube.com/embed/videoseries?list=${playlistId}`;
}

function decodeXml(value: string): string {
  return value
    .replace(/<!\[CDATA\[([\s\S]*?)\]\]>/g, '$1')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}

function firstTag(block: string, tag: string): string {
  const re = new RegExp(`<${tag}[^>]*>([\\s\\S]*?)</${tag}>`, 'i');
  const match = block.match(re);
  return match ? decodeXml(match[1].trim()) : '';
}

/** Parse YouTube Atom RSS (`feeds/videos.xml?playlist_id=`). */
export function parseYoutubeAtomFeed(xml: string): PlaylistVideo[] {
  const chunks = xml.split(/<entry[\s>]/i).slice(1);
  const videos: PlaylistVideo[] = [];
  for (const chunk of chunks) {
    const id =
      firstTag(chunk, 'yt:videoId') ||
      (chunk.match(/yt:video:([A-Za-z0-9_-]{11})/)?.[1] ?? '');
    if (!id) continue;
    videos.push({
      id,
      title: firstTag(chunk, 'title') || 'Untitled Video',
      description: firstTag(chunk, 'media:description'),
      publishedAt: firstTag(chunk, 'published'),
      thumbnail: youtubeThumbnail(id),
      channelTitle: firstTag(chunk, 'name') || 'SportsFuture',
    });
  }
  return videos;
}

export async function fetchPlaylistVideos(
  playlistId: string = SPORTS_FUTURE_PLAYLIST_ID,
  maxResults = 12,
  fetchImpl: typeof fetch = fetch
): Promise<PlaylistVideo[]> {
  const res = await fetchImpl(`/api/youtube-rss/${encodeURIComponent(playlistId)}`);
  if (!res.ok) {
    throw new Error(`YouTube playlist feed failed (${res.status})`);
  }
  const xml = await res.text();
  return parseYoutubeAtomFeed(xml).slice(0, maxResults);
}
